import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromProfile from '../reducers/profile.reducer';

const getState = createFeatureSelector<fromProfile.State>(fromProfile.FEATURE_KEY);

export const getProfile = createSelector(
  getState,
  state => state.profile.entities[Object.keys(state.profile.entities)[0]],
);
export const getProfileLoading = createSelector(getState, state => state.profile.loading);
export const getProfileError = createSelector(getState, state => state.profile.error);
export const getProfileLoaded = createSelector(getState, state => state.profile.loaded);

const getAgiState = createSelector(getState, state => state.agis);
export const getAgis = createSelector(getAgiState, fromProfile.agiAdapter.getSelectors().selectAll);
export const getAgisLoaded = createSelector(getState, state => state.agis.loaded);
export const getAgisError = createSelector(getState, state => state.agis.error);

const getPartnersState = createSelector(getState, state => state.partners);
export const getPartners = createSelector(getPartnersState, fromProfile.partnerAdapter.getSelectors().selectAll);
export const getPartnersLoading = createSelector(getState, state => state.partners.loading);
export const getPartnersError = createSelector(getState, state => state.partners.error);

const getAddressState = createSelector(getState, state => state.addresses);
export const getAddressesLoaded = createSelector(getAddressState, state => state.loaded);
export const getAddressesError = createSelector(getAddressState, state => state.error);
export const getAddresses = createSelector(getAddressState, fromProfile.addressAdapter.getSelectors().selectAll);

const getPartnerRolesState = createSelector(getState, state => state.partnerRoles);
export const getPartnerRolesLoaded = createSelector(getPartnerRolesState, state => state.loaded);
export const getPartnerRolesError = createSelector(getPartnerRolesState, state => state.error);
export const getPartnerRoles = createSelector(
  getPartnerRolesState,
  fromProfile.partnerRoleAdapter.getSelectors().selectAll,
);

const getContactsState = createSelector(getState, state => state.contacts);

export const getOrgContactsStateByOrgId = (orgId: string) =>
  createSelector(getContactsState, contacts => contacts?.[orgId]);

// Bucket-level flags (optional)
export const getContactsLoadingByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => !!bucket?.loading);

export const getContactsLoadedByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => !!bucket?.loaded);

export const getContactsErrorByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => !!bucket?.error);

// Internal
export const getInternalContactsStateByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => bucket?.internal);

export const getFunctionContactsStateByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => bucket?.function);

export const getInternalContactsByOrgId = (orgId: string) =>
  createSelector(getInternalContactsStateByOrgId(orgId), intState =>
    intState ? fromProfile.internalContactAdapter.getSelectors().selectAll(intState) : [],
  );

export const getFunctionContactsByOrgId = (orgId: string) =>
  createSelector(getFunctionContactsStateByOrgId(orgId), intState =>
    intState ? fromProfile.functionContactAdapter.getSelectors().selectAll(intState) : [],
  );

export const getFunctionContactsLoadingByOrgId = (orgId: string) =>
  createSelector(getFunctionContactsStateByOrgId(orgId), funcState => !!funcState?.loading);

export const getFunctionContactsLoadedByOrgId = (orgId: string) =>
  createSelector(getFunctionContactsStateByOrgId(orgId), funcState => !!funcState?.loaded);

export const getInternalContactsLoadingByOrgId = (orgId: string) =>
  createSelector(getInternalContactsStateByOrgId(orgId), intState => !!intState?.loading);

export const getInternalContactsLoadedByOrgId = (orgId: string) =>
  createSelector(getInternalContactsStateByOrgId(orgId), intState => !!intState?.loaded);

// External
export const getExternalContactsStateByOrgId = (orgId: string) =>
  createSelector(getOrgContactsStateByOrgId(orgId), bucket => bucket?.external);

export const getExternalContactsByOrgId = (orgId: string) =>
  createSelector(getExternalContactsStateByOrgId(orgId), extState =>
    extState ? fromProfile.externalContactAdapter.getSelectors().selectAll(extState) : [],
  );

export const getExternalContactsLoadingByOrgId = (orgId: string) =>
  createSelector(getExternalContactsStateByOrgId(orgId), extState => !!extState?.loading);

export const getExternalContactsLoadedByOrgId = (orgId: string) =>
  createSelector(getExternalContactsStateByOrgId(orgId), extState => !!extState?.loaded);
